import React from 'react';
import {
  CHARACTER_CANVAS_HEIGHT,
  CHARACTER_CANVAS_WIDTH,
  CHARACTER_LAYER_RENDER_ORDER,
  type CharacterLayerSlot
} from '../../types/character';
import { DEFAULT_CHARACTER_BASE_DATA_URL, getLayerZIndex } from '../../utils/characterSpec';

export interface LayeredCharacterProps {
  /** 슬롯별 이미지 URL. base 미지정 시 기본 더미 베이스 사용 */
  layers: Partial<Record<CharacterLayerSlot, string | null | undefined>>;
  /** 논리 32px 기준 확대 배율 */
  scale?: number;
  'aria-label'?: string;
}

const LayeredCharacter: React.FC<LayeredCharacterProps> = ({
  layers,
  scale = 4,
  'aria-label': ariaLabel = '픽셀 캐릭터'
}) => {
  const boxW = CHARACTER_CANVAS_WIDTH * scale;
  const boxH = CHARACTER_CANVAS_HEIGHT * scale;

  return (
    <div
      role="img"
      aria-label={ariaLabel}
      style={{
        position: 'relative',
        width: `${boxW}px`,
        height: `${boxH}px`,
        overflow: 'hidden',
        flexShrink: 0
      }}
    >
      {CHARACTER_LAYER_RENDER_ORDER.map((slot) => {
        const url =
          slot === 'base'
            ? layers.base || DEFAULT_CHARACTER_BASE_DATA_URL
            : layers[slot];
        if (!url) return null;
        return (
          <img
            key={slot}
            src={url}
            alt=""
            draggable={false}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: `${boxW}px`,
              height: `${boxH}px`,
              imageRendering: 'pixelated',
              objectFit: 'fill',
              pointerEvents: 'none',
              zIndex: getLayerZIndex(slot)
            }}
          />
        );
      })}
    </div>
  );
};

export default LayeredCharacter;
